module.exports = __webpack_public_path__ + "img/call-types-incoming.705b02d8.svg";